import Tools from '@/components/tools/Tools.js'
import { toast, loading } from '@/shared/utils/UIHelper'
import { JWTService } from '@/shared/services/jwt'

import ModalSinisterTyping from './modal/modalsinistertyping.vue'
import ModalSinisterClosing from './modal/modalsinisterclosing.vue'
import {en, es, ptBR} from 'vuejs-datepicker/dist/locale'
import Datepicker from 'vuejs-datepicker'
import ActionsForm from '@/shared/mixins/actionsForm'

import CarInspectionHeader from '@/components/regulation/auto/carinspectionheader/carinspectionheader.vue'
import RegulationAutoRepository from '@/shared/http/repositories/regulation/auto/regulationauto.js'
import RegulationAutoTypingRepository from '@/shared/http/repositories/regulation/auto/regulationautotyping'
import RegulationAutoDigitationComplementary from '@/shared/http/repositories/regulation/auto/regulationautotypingcomplement.js'
import SinisterTypingForm from './sinistertyping-form'
import SinisterTypingModel from './sinitertyping-model'

import RegulationMixin from '@/store/module/regulation/mixin'
import PermissionMixin from '@/store/module/permission/mixin'
import Roles from '@/shared/utils/roles.js'

export default {
  name: 'SinisterTyping',
  props: [ 'clear' ],
  mixins: [
    ActionsForm,
    RegulationMixin,
    PermissionMixin
  ],
  data () {
    return {
      roles: Roles,
      data: SinisterTypingModel,
      form: SinisterTypingForm,
      objRegulationAuto: null,
      model: '',
      modelOptions: [],
      items: [],
      moneyFormat: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      },
      en: en,
      es: es,
      ptBR: ptBR,
      disableActionDateTyping: false
    }
  },
  components: {
    Datepicker,
    CarInspectionHeader,
    ModalSinisterTyping,
    ModalSinisterClosing
  },
  mounted () {
    this.onLoad()
  },
  watch: {
    // TODO RETIRAR APÓS REFACTOR
    clear: function () {
      this.onClear()
    }
  },
  methods: {
    onClearTabs () {
      this.$emit('ClearTabs', this.onClear)
    },
    onClosed (data) {
      this.regulation.stageID = data.stageID
      this.$emit('Edit', this.regulation)
    },
    formatPrice (value) {
      let val = (value / 1).toFixed(2).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    onClear () {
      Tools.SetFormDefaultValues(this.form)
    },
    onLoad (obj) {
      this.onClear()
      if (this.hasRegulation) {
        this.data.actionDate = this.moment().format('YYYY-MM-DD hh:mm:ss')
        this.data.regulationAutoID = this.regulation.id
        this.form.regulationAutoID.value = this.regulation.id
        RegulationAutoTypingRepository.GetByRegulationAutoID(this.regulation.id)
          .then((response) => {
            var result = this.onResultObj(response)
            this.form.id.value = '00000000-0000-0000-0000-000000000000'
            if (result !== null) {
              this.form.id.value = result.id
              this.form.initialSurveyBudgetedLabor.value = result.initialSurveyBudgetedLabor || 0
              this.form.initialSurveyApprovedLabor.value = result.initialSurveyApprovedLabor || 0
              this.form.insuranceBudgetedLabor.value = result.insuranceBudgetedLabor || 0
              this.form.insuranceApprovedLabor.value = result.insuranceApprovedLabor || 0
              this.form.description.value = result.description
            }
          })
          .catch((err) => {
            this.onException(err)
          })
        this.onLoadAllComplement()
      }
    },
    onSetAccomplished () {
      if (this.hasRegulation) {
        loading.push()
        this.onLoadAllComplement()
        RegulationAutoRepository.ChangeStageRegulationAccomplished(this.regulation.id)
          .then((response) => {
            loading.close()
            if (response.data.code >= 0) {
              var data = response.data.data
              this.regulation.stageID = data.stageID
              this.$emit('Edit', this.regulation)
              loading.close()
            }
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onLoadAllComplement () {
      if (this.hasRegulation) {
        loading.push()
        RegulationAutoDigitationComplementary.GetAllPaging(this.regulation.id, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
          .then((response) => {
            this.onResultGrid(response)
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onAddComplement () {
      if (this.hasRegulation) {
        console.log(this.$refs.ModalSinisterTyping)
        this.$refs.ModalSinisterTyping.showModal(this.regulation.id)
      } else {
        toast.info('ATENÇÃO! Você precisa selecionar uma vistoria!')
      }
    },
    onEditComplement (obj) {
      this.$refs.ModalSinisterTyping.editShoModal(obj, this.isCompleted)
    },
    onDeleteComplement (obj) {
      loading.push()
      RegulationAutoDigitationComplementary.Delete(obj.id)
        .then((response) => {
          this.onLoadAllComplement()
          loading.close()
          if (response.data.code >= 0) {
            toast.success(this.$lang.Common.Alerts.Success)
          }
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onSave () {
      var self = this
      if (this.form.id.value === '') {
        this.form.id.value = '00000000-0000-0000-0000-000000000000'
      }
      this.data.id = this.form.id.value
      this.form.regulationAutoID.value = this.regulation.id
      if (Tools.ValidateForms(this.form, this.data, self)) {
        // Set default data
        this.data.dateUpdate = this.moment().format('YYYY-MM-DD hh:mm:ss')
        this.data.accountIDUpdate = JWTService.GetTokenPayload().AccountID
        if (this.data) {
          this.data.status = 1
          this.onCreate()
        } else {
          toast.error(this.$lang.Common.NoRecordInformed)
        }
      }
    },
    onCreate () {
      loading.push()
      RegulationAutoTypingRepository.Create(this.data)
        .then((response) => {
          var result = this.onResultObj(response)
          if (result !== null) {
            this.onLoad(result.regulationAutoID)
          }
          this.onResult(response, true, true)
          this.onSetAccomplished()
          // this.$refs.ModalSinisterClosing.showModal(this.regulation.id)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onUpdate () {
      loading.push()
      RegulationAutoTypingRepository.Update(this.data)
        .then((response) => {
          this.onResult(response, true, true)
          this.onSetAccomplished()
          // this.$refs.ModalSinisterClosing.showModal(this.regulation.id)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onEdit (obj) {
      loading.push()
      Tools.SetValueInForm(this.form, this.data, obj)
      loading.pop()
    },
    onEditByID (ID) {
      if (ID && ID !== '00000000-0000-0000-0000-000000000000') {
        RegulationAutoTypingRepository.GetByID(ID)
          .then((response) => {
            var obj = this.onResultObj(response)
            if (obj !== null) {
              this.onEdit(obj)
            }
          })
          .catch((err) => {
            this.onException(err)
          })
      }
    },
    onEditByRegulationAuto (obj) {
      if (obj && obj !== null) {
        this.objRegulationAuto = obj
        if (obj && obj.id !== '00000000-0000-0000-0000-000000000000') {
          RegulationAutoTypingRepository.GetByRegulationAutoID(obj.id)
            .then((response) => {
              var obj = this.onResultObj(response)
              if (obj !== null) {
                this.onEdit(obj)
              }
            })
            .catch((err) => {
              this.onException(err)
            })
        }
      }
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          if (this.permissions[i].role === role) {
            result = true
          }
        }
      }
      return result
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/inspection/typing/sinistertyping.js